// extracted by mini-css-extract-plugin
export var fullWidthButton = "_he-0";